import { Component } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { FunctionsService } from '../app/functions/functions.service';

import { NavController } from '@ionic/angular';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent {
  public appPages = [];

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private fun : FunctionsService,
    public navCtrl : NavController
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      if(this.fun.is_app()) {
        this.statusBar.styleDefault();
        this.splashScreen.hide();
      }
    });
  }

  logout() {
    localStorage.clear();
    this.navCtrl.navigateRoot('login');
  }
}
